/* unplugin-vue-components disabled */import script from "./ProductDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetail.vue?vue&type=style&index=0&id=fbaff1ec&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbaff1ec"]])

export default __exports__